import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import LoginForm from "./components/LoginForm";

function App() {
  return (
    <Router>
      <Routes>
        {/* Redirect from "/" to "/authenticate" */}
        <Route path="/" element={<Navigate to="/authenticate" replace />} />
        <Route path="/authenticate" element={<LoginForm />} />
      </Routes>
    </Router>
  );
}

export default App;
